<template>
  <div class="hero-banner">
    <h1 class="hero-banner__title" v-html="title"/>
    <h2 class="hero-banner__subtitle" v-html="subtitle"/>
  </div>
</template>

<script>
export default {
  name: 'HeroBanner',
  props: {
    title: String,
    subtitle: String
  }
}
</script>

<style lang="scss" scoped>
.hero-banner {
  padding: 3rem;
  background: $secondary-gradient;
  text-align: center;
  &__title {
    color: white;
    font-size: 2rem;
    font-weight: 300;
  }
  &__subtitle {
    color: white;
    font-size: 1.2rem;
    font-weight: 300;
  }
}
</style>